import { render, staticRenderFns } from "./QuoteTile.vue?vue&type=template&id=4f54b4ba&scoped=true&"
import script from "./QuoteTile.vue?vue&type=script&lang=js&"
export * from "./QuoteTile.vue?vue&type=script&lang=js&"
import style0 from "./QuoteTile.vue?vue&type=style&index=0&id=4f54b4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54b4ba",
  null
  
)

export default component.exports